import { NodeDefinition } from 'Automations/nodeDefinitions/types'
import { ActionEditorNode } from '../action.editorNode'
import { ActionIcon } from '../action.icon'
import { ActionPlaceholderNodeConfigForm } from './actionPlaceholder.configForm'
import { actionTypeRequired, handlesConnected } from '../action.validators'
import { Config } from './actionPlaceholder.types'

export type { Config }

export const actionPlaceholderNodeDefinition: NodeDefinition<Config> = {
  name: 'Action',
  editorNode: ActionEditorNode,
  configForm: ActionPlaceholderNodeConfigForm,
  icon: ActionIcon,
  defaultConfig: {
    name: '',
    actionType: undefined
  },
  validation: {
    node: { ERROR: [], WARN: [] },
    config: {
      name: { ERROR: [], WARN: [] },
      actionType: { ERROR: [actionTypeRequired], WARN: [] }
    },
    handles: { ERROR: [handlesConnected], WARN: [] }
  },
  taskTransformer: () => []
}
